import { IOptionAnyValue } from 'bricks/types';
import { AssetTypeIds } from 'components/DealForm/constants';
import { useGetDealFormSelectOptions } from 'components/DealForm/hooks/useGetDealFormSelectOptions';
import useAuthContext from 'contexts/AuthContext';
import { useMemo } from 'react';
import { SpecsData } from 'views/InvestmentMemo/types';
import {
    proFormaModelParkingOptions,
} from 'views/ProFormaTable/constants';

export const useSpecsLoader = (specs: SpecsData) => {
    const { selectedOrganizationId } = useAuthContext();

    const {
        data: {
            assetTypeOptions,
        },
        getSelectedAssetType,
        loadingStates,
    } = useGetDealFormSelectOptions(selectedOrganizationId);

    const getSubTypeOptions = (assetTypeId: string): IOptionAnyValue<string>[] => getSelectedAssetType(assetTypeId)?.subAssetTypes
        ?.filter(({ description }) => description)
        ?.map(({ correlationId, description }) => ({
            label: description || '',
            value: correlationId,
        })) || [];

    const initialSubTypeOptions = specs?.assetType?.correlationId
        ? getSubTypeOptions(specs.assetType.correlationId)
        : getSubTypeOptions(AssetTypeIds.RentalApartment);

    const parkingOptionsForModel = useMemo(
        () => (specs.proFormaModelId ? proFormaModelParkingOptions[specs.proFormaModelId] : []),
        [specs.proFormaModelId],
    );

    return {
        assetTypeOptions,
        loadingStates,
        getSubTypeOptions,
        initialSubTypeOptions,
        parkingOptionsForModel,
    };
};
